<h5 class="mb-3">
  {{ "Template.EmployeesComponent.subHeader_userAccesses" | translate }}:
  @if (party) {
    <button class="btn btn-sm btn-success float-end" (click)="createOrUpdateUser()" [disabled]="!party.enabled">
      <fa-icon icon="user-plus"></fa-icon>
      {{ "Template.EmployeesComponent.btn_createUserAccess" | translate }}
    </button>
  }
</h5>

@if (!loadingEmployees && employees?.length) {
  <table class="table">
    <tbody>
      @for (employee of employees; track employee; let i = $index) {
        <tr class="border-bottom">
          <td>
            <app-employee [username]="employee" [party]="party" (loadingEvent)="showLoader($event)" (reloadEvent)="reload()"></app-employee>
          </td>
        </tr>
      }
    </tbody>
  </table>
}

@if (!loadingEmployees && (!employees || !employees.length)) {
  <strong>{{ "Template.EmployeesComponent.text_noUserAccessesCreated" | translate }}</strong>
}

@if (loadingEmployees) {
  <fa-icon icon="spinner" size="2x" animation="spin" class="ms-3"></fa-icon>
}
